import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import HomePage from "@/pages/HomePage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import NotFound from "@/pages/NotFound";
import BlogList from "@/pages/BlogList";
import BlogPost from "@/pages/BlogPost";
import LandingRoute from "@/pages/Landing";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen bg-[#f9f8f5] p-10 text-[#6b6a65]">Loading…</div>;
  if (!user) return <Navigate to="/admin" replace />;
  return children;
}

export default function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <AuthProvider>
            <Toaster position="top-right" richColors toastOptions={{ style: { background: "#ffffff", color: "#202124", border: "1px solid #e7e0d6" } }} />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/blog" element={<BlogList />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/franchise/ayurvedic-pcd" element={<LandingRoute />} />
              <Route path="/manufacturing/:kind" element={<LandingRoute />} />
              <Route path="/products/:type" element={<LandingRoute />} />
              <Route path="/franchise/:state" element={<LandingRoute />} />
              <Route path="/franchise/:state/:city" element={<LandingRoute />} />
              <Route path="/admin" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </AuthProvider>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}
